module.exports = __webpack_public_path__ + "static/media/inventory-main.2a934ff7.png";